"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Item(_ref) {
  var _cn;

  var size = _ref.size;
  var itemClassName = (0, _classnames["default"])(_defaultModule["default"]['item'], (_cn = {}, (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['size--big'], size === 'big'), (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['size--middle'], size === 'middle'), (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['size--small'], size === 'small'), _cn));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: itemClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['blink']
  }));
}

Item.defaultProps = {
  order: 'default'
};
var _default = Item;
exports["default"] = _default;